module.exports = __webpack_public_path__ + "static/media/icon_mg02.27ef47ff.svg";